/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { OnlineCode } from '../../models/online-code';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreateOnlineCode$Params {
  market: string;
  subProcess: string;
  dataVersion: string;
  vehicleId: string;
  'x-owcc-appversion'?: string;
  'x-owcc-usergroup'?: string;
  'x-owcc-saleslevel'?: string;
  'x-owcc-configurationdate'?: string;
  'x-owcc-zipcode'?: string;
  'x-owcc-carllabel'?: string;
  'x-owcc-formattingtag'?: string;
  'X-B2XCORE_AUTHENTICATION'?: string;
}

export function createOnlineCode(
  http: HttpClient,
  rootUrl: string,
  params: CreateOnlineCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<OnlineCode>> {
  const rb = new RequestBuilder(rootUrl, createOnlineCode.PATH, 'post');
  if (params) {
    rb.path('market', params.market, {});
    rb.path('subProcess', params.subProcess, {});
    rb.path('dataVersion', params.dataVersion, {});
    rb.path('vehicleId', params.vehicleId, {});
    rb.header('x-owcc-appversion', params['x-owcc-appversion'], {});
    rb.header('x-owcc-usergroup', params['x-owcc-usergroup'], {});
    rb.header('x-owcc-saleslevel', params['x-owcc-saleslevel'], {});
    rb.header('x-owcc-configurationdate', params['x-owcc-configurationdate'], {});
    rb.header('x-owcc-zipcode', params['x-owcc-zipcode'], {});
    rb.header('x-owcc-carllabel', params['x-owcc-carllabel'], {});
    rb.header('x-owcc-formattingtag', params['x-owcc-formattingtag'], {});
    rb.header('X-B2XCORE_AUTHENTICATION', params['X-B2XCORE_AUTHENTICATION'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OnlineCode>;
    })
  );
}

createOnlineCode.PATH = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/onlinecodes/';
